export { default } from './SpacingBox'
export type { SpacingBoxProps } from './SpacingBox'
